import { LoaderModule } from './shared/loader/loader.module';
import { PetrolSalesModule } from './IPlaceDashboard/petrol-sales/petrol-sales.module';
import { PetrolRankingModule } from './petrolRanking/PetrolRanking.module';
import { NgModule }                   from '@angular/core';
import { BrowserModule }              from '@angular/platform-browser';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule }    from '@angular/platform-browser/animations';
import { HttpClientModule }           from '@angular/common/http';
import { DatePipe }                   from '@angular/common';
import { FlexLayoutModule }           from '@angular/flex-layout';
import { FormsModule,
         ReactiveFormsModule }        from '@angular/forms';
import { NgxDatatableModule }         from '@swimlane/ngx-datatable';
import { TabsModule }                 from 'ngx-bootstrap/tabs';
import { BsDropdownModule }           from 'ngx-bootstrap/dropdown';
import { ModalModule }                from 'ngx-bootstrap/modal';
import { BsDatepickerModule }         from 'ngx-bootstrap/datepicker';
import { TimepickerModule }           from 'ngx-bootstrap/timepicker';
import { DatepickerModule }           from 'ngx-bootstrap/datepicker';
import { SimpleNotificationsModule }  from "angular2-notifications";
import { NgxGalleryModule }           from 'ngx-gallery';
import { InfiniteScrollModule }       from 'ngx-infinite-scroll';
import { AngularMultiSelectModule }   from 'angular2-multiselect-dropdown';
import { NgxGaugeModule }             from 'ngx-gauge';
import { HighchartsChartModule }      from 'highcharts-angular';
import { Md2Module } from 'angular-md2';
import { GridsterModule } from 'angular-gridster2';
import { NgxMaskModule } from 'ngx-mask'

import { AppRoutingModule } from './app-routing.module';
import { AuthModule }       from "./shared/auth/auth.module";

import { AppComponent }             from './app.component';
import { MainComponent }            from './main.component';
import { DashboardComponent }       from "./dashboard/dashboard.component";
import { ProfileComponent }         from "./profile/profile.component";
import { IPlaceService }            from "./iPlace/iPlace.service";
import { CloudUserService }         from "./profile/cloudUser.service";
import { IPlaceStatusPipe }         from "./iPlace/iPlace-status.pipe";
import { CloudUserListComponent }   from "./admin/cloudUser-list.component";
import { CloudUserRolePipe }        from "./admin/cloudUser-role.pipe";
import { CloudUserDetailComponent } from "./admin/cloudUser-detail.component";
import { CloudAccountService }      from "./profile/cloudAccount.service";
import { CloudUserIPlaceService }   from "./iPlace/cloudUseriPlace.service";
import { I18NService }              from "./shared/i18n/i18n.service";
import { TmpI18NComponent }         from "./i18n/tmp.i18n.component";
import {NotificationListComponent} from "./notification/notification-list.component";
import {NotificationService} from "./notification/notification.service";
import {NotificationDetailComponent} from "./notification/notification-detail.component";
import {NotificationReceiverStatusPipe} from "./notification/notificationReceiver-status.pipe";
import {IPlaceDashboardMainComponent} from "./IPlaceDashboard/IPlaceDashboardMain.component";
import {SectionService} from "./IPlaceDashboard/section/Section.service";
import {WidgetService} from "./IPlaceDashboard/widget/Widget.service";
import {GadgetService} from "./IPlaceDashboard/gadget/Gadget.service";
import {TreeViewMenuComponent} from "./shared/component/tree-view-menu/TreeViewMenu.component";
import {TreeViewComponent} from "./shared/component/tree-view-menu/TreeView.component";
import {GadgetMapComponent} from "./IPlaceDashboard/component/gadget-map/GadgetMap.component";
import {ElementGroupComponent} from "./IPlaceDashboard/component/element-group/ElementGroup.component";
import {GadgetGroupComponent} from "./IPlaceDashboard/component/gadget-group/GadgetGroup.component";
import {PumpComponent} from "./IPlaceDashboard/component/pump/Pump.component";
import {PricePoleComponent} from "./IPlaceDashboard/component/price-pole/PricePole.component";
import {TankComponent} from "./IPlaceDashboard/component/tank/Tank.component";
import {WidgetStatusIconComponent} from "./IPlaceDashboard/component/widget-status/WidgetStatusIcon.component";
import {IPlaceDataChangeService} from "./IPlaceDashboard/IPlaceDataChange.service";
import {WidgetStatusFooterComponent} from "./IPlaceDashboard/component/widget-status/WidgetStatusFooter.component";
import {StatusNotificationService} from "./IPlaceDashboard/statusNotification/StatusNotification.service";
import {NotificationMessageService} from "./IPlaceDashboard/notificationMessage/NotificationMessage.service";
import {ErrorDashboardComponent} from "./IPlaceDashboard/errorDashboard/ErrorDashboard.component";
import {IPlaceDashboardComponent} from "./IPlaceDashboard/iPlaceDashboard/IPlaceDashboard.component";
import {IPlaceValuelistService} from "./iPlace/iPlace-valuelist.service";
import {IPlacePipe} from "./iPlace/iPlace.pipe";
import {GadgetComponent} from "./IPlaceDashboard/component/gadget/Gadget.component";
import {CloudNotificationListComponent} from "./IPlaceDashboard/notification/CloudNotificationList.component";
import {CloudNotificationSolvedTypePipe} from "./IPlaceDashboard/notification/CloudNotificationSolvedType.pipe";
import {RuleService} from "./IPlaceDashboard/rule/Rule.service";
import {ElementService} from "./IPlaceDashboard/element/Element.service";
import {SurveillanceComponent} from "./IPlaceDashboard/surveillance/Surveillance.component";
import {RankingComponent} from "./IPlaceDashboard/ranking/Ranking.component";
import {RecordingsComponent} from "./IPlaceDashboard/recordings/Recordings.component";
import {SalesComponent} from "./IPlaceDashboard/sales/Sales.component";
import {ReconciliationComponent} from "./IPlaceDashboard/reconciliation/Reconciliation.component";
import {ClearViewService} from "./IPlaceDashboard/clearView/ClearView.service";
import {CameraComponent} from "./IPlaceDashboard/component/streaming/Camera.component";
import {HLSCameraComponent} from "./IPlaceDashboard/component/streaming/HLSCamera.component";
import {StartComponent} from "./IPlaceDashboard/start/Start.component";
import {HistoricComponent} from "./IPlaceDashboard/historic/Historic.component";
import {JournalComponent} from "./IPlaceDashboard/journal/Journal.component";
import {MockComponent} from "./IPlaceDashboard/component/mock/Mock.component";
import {ChartsComponent} from "./IPlaceDashboard/charts/Charts.component";
import {ConfigurationComponent} from "./IPlaceDashboard/configuration/Configuration.component";
import {IndicatorComponent} from "./IPlaceDashboard/component/indicator/Indicator.component";
import {ChartComponent} from "./IPlaceDashboard/component/chart/Chart.component";
import {DateTimePickerComponent} from "./IPlaceDashboard/component/datetime-picker/DateTimePicker.component";
import {IPlaceFinderComponent} from "./IPlaceDashboard/iPlace/IPlaceFinder.component";
import {TagService} from "./IPlaceDashboard/tag/Tag.service";
import {IPlaceBreadCrumbComponent} from "./IPlaceDashboard/iPlace/IPlaceBreadCrumb.component";
import {Globals} from "./globals";
import {IPlaceSectionComponent} from "./IPlaceDashboard/iPlace/IPlaceSection.component";
import {TankDeliveryNoteComponent} from "./IPlaceDashboard/tankDeliveryNote/TankDeliveryNote.component";
import {TankDeliveryNoteService} from "./IPlaceDashboard/tankDeliveryNote/TankDeliveryNote.service";
import {TankService} from "./IPlaceDashboard/ipetrol/Tank.service";
import {PetrolStatisticsComponent} from "./IPlaceDashboard/petrol_statistics/PetrolStatistics.component";
import {PetrolStatisticsService} from "./IPlaceDashboard/petrol_statistics/PetrolStatistics.service";
import {PetrolDiscountTransactionService} from "./IPlaceDashboard/petrolDiscount/PetrolDiscountTransaction.service";
import {PetrolDiscountTransactionComponent} from "./IPlaceDashboard/petrolDiscount/PetrolDiscountTransaction.component";
import {PetrolSettlementReportComponent} from "./IPlaceDashboard/petrolDiscount/PetrolSettlementReport.component";
import {PetrolSettlementReportService} from "./IPlaceDashboard/petrolDiscount/PetrolSettlementReport.service";
import { EcopricingComponent } from './IPlaceDashboard/ecopricing/Ecopricing.component';
import { EcosensorComponent } from './IPlaceDashboard/ecosensor/Ecosensor.component';
import { EcomplianceComponent } from './IPlaceDashboard/ecompliance/Ecompliance.component';
import { CEIComponent } from './IPlaceDashboard/cei/CEI.component';
import {EcomanagerService} from './IPlaceDashboard/ecomanager/Ecomanager.service';
import { SidebarItemComponent } from './shared/component/sidebar-item/SidebarItem.component';
import {SidebarGeneratorService} from './shared/component/sidebar-item/SidebarGenerator.service';
import {SurveillanceGridComponent} from "./IPlaceDashboard/surveillance/SurveillanceGrid.component";
import {SurveillanceService} from "./IPlaceDashboard/surveillance/Surveillance.service";
import {SurveillanceCameraStreamingComponent} from "./IPlaceDashboard/surveillance/SurveillanceCameraStreaming.component";
import {ShortNumberPipe} from "./shared/pipe/shortNumber.pipe";
import {EcosensorLogService} from './IPlaceDashboard/ecosensor/EcosensorLog.service';
import {IPetrolDemoService} from "./IPlaceDashboard/recordings/IPetrolDemo.service";
import { TankLevelsComponent } from './IPlaceDashboard/ipetrol/tank-levels/tank-levels.component';
import { TankChartComponent } from './IPlaceDashboard/ipetrol/tank-levels/tank-chart.component';
import { TankHistoricComponent } from './IPlaceDashboard/ipetrol/tank-historic/tank-historic.component';
import { ChartHistoricComponent } from './IPlaceDashboard/ipetrol/tank-historic/chart-historic.component';
import { TankBooksComponent } from './IPlaceDashboard/ipetrol/tank-books/tank-books.component';
import { LevelsGraphComponent } from './IPlaceDashboard/ipetrol/levels-graph/levels-graph.component';
import { LevelsChartComponent } from './IPlaceDashboard/ipetrol/levels-graph/levels-chart.component';
import { ManualTransactionsComponent } from './IPlaceDashboard/manualTransactions/manualTransactions.component';
import { MonitoredEquipmentListComponent } from './IPlaceDashboard/sergas/monitoredEquipment/monitored-equipment-list/monitored-equipment-list.component';
import { MonitoredEquipmentDetailComponent } from './IPlaceDashboard/sergas/monitoredEquipment/monitored-equipment-detail/monitored-equipment-detail.component';
import {IncidenceListComponent} from "./IPlaceDashboard/sergas/incidence/IncidenceList.component";
import {IncidenceService} from "./IPlaceDashboard/sergas/incidence/incidence.service";
import {IncidenceDetailComponent} from "./IPlaceDashboard/sergas/incidence/incidence-detail/incidence-detail.component";
import {SergasDeviceService} from "./IPlaceDashboard/sergas/device/SergasDevice.service";
import {SergasDeviceValuelistService} from "./IPlaceDashboard/sergas/device/SergasDeviceValuelist.service";
import {SergasDevicePipe} from "./IPlaceDashboard/sergas/device/SergasDevice.pipe";
import {NumberValueAccessor} from "./shared/directive/numberValue-accessor";
import {OnlyNumber} from "./shared/directive/onlyNumber.directive";
import { GenerateReportComponent } from './IPlaceDashboard/sergas/generate-report/generate-report.component';


export class CustomHammerConfig extends HammerGestureConfig  {
  overrides = {
    pinch: { enable: false },
    rotate: { enable: false }
  };
}

@NgModule({
  imports:      [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    NgxGalleryModule,
    InfiniteScrollModule,
    AngularMultiSelectModule,
    NgxGaugeModule,
    HighchartsChartModule,
    Md2Module,
    NgxMaskModule.forRoot(),
    AuthModule.forRoot({
      loginPath: "api/v1/login",
      loginDemoPath: "api/v1/login/demo",
      signUpPath:"api/v1/signup",
      activatePath:"api/v1/activate",
      passwordRecoverPath:"api/v1/password/recovery",
      passwordResetPath:"api/v1/password/reset",
      defaultRoute: [""]
    }),
    PetrolRankingModule,
    PetrolSalesModule,
    LoaderModule,
    GridsterModule
  ],
  declarations: [
    AppComponent,
    MainComponent,
    DashboardComponent,
    ProfileComponent,
    IPlaceStatusPipe,
    CloudUserListComponent,
    CloudUserDetailComponent,
    CloudUserRolePipe,
    NotificationListComponent,
    NotificationDetailComponent,
    NotificationReceiverStatusPipe,
    TmpI18NComponent,
    IPlaceDashboardMainComponent,
    IPlaceDashboardComponent,
    ErrorDashboardComponent,
    TreeViewMenuComponent,
    TreeViewComponent,
    GadgetMapComponent,
    ElementGroupComponent,
    GadgetGroupComponent,
    TankComponent,
    PumpComponent,
    PricePoleComponent,
    WidgetStatusIconComponent,
    WidgetStatusFooterComponent,
    IPlacePipe,
    GadgetComponent,
    CloudNotificationListComponent,
    CloudNotificationSolvedTypePipe,
    SurveillanceComponent,
    RankingComponent,
    RecordingsComponent,
    SalesComponent,
    ReconciliationComponent,
    CameraComponent,
    HLSCameraComponent,
    StartComponent,
    HistoricComponent,
    JournalComponent,
    MockComponent,
    ChartsComponent,
    ConfigurationComponent,
    IndicatorComponent,
    ChartComponent,
    DateTimePickerComponent,
    IPlaceSectionComponent,
    IPlaceFinderComponent,
    IPlaceBreadCrumbComponent,
    TankDeliveryNoteComponent,
    IPlaceBreadCrumbComponent,
    PetrolStatisticsComponent,
    PetrolDiscountTransactionComponent,
    PetrolSettlementReportComponent,
    EcopricingComponent,
    EcosensorComponent,
    EcomplianceComponent,
    CEIComponent,
    SidebarItemComponent,
    SurveillanceGridComponent,
    SurveillanceCameraStreamingComponent,
    ShortNumberPipe,
    TankLevelsComponent,
    TankChartComponent,
    TankHistoricComponent,
    ChartHistoricComponent,
    TankBooksComponent,
    LevelsGraphComponent,
    LevelsChartComponent,
    ManualTransactionsComponent,
    MonitoredEquipmentListComponent,
    MonitoredEquipmentDetailComponent,
    IncidenceListComponent,
    IncidenceDetailComponent,
    SergasDevicePipe,
    NumberValueAccessor,
    OnlyNumber,
    GenerateReportComponent
  ],
  entryComponents: [IPlaceSectionComponent],
  providers: [
    IPlaceService,
    CloudUserService,
    CloudAccountService,
    CloudUserIPlaceService,
    NotificationService,
    I18NService,
    SectionService,
    WidgetService,
    GadgetService,
    IPlaceDataChangeService,
    StatusNotificationService,
    NotificationMessageService,
    IPlaceValuelistService,
    RuleService,
    ElementService,
    ClearViewService,
    EcomanagerService,
    EcosensorLogService,
    TagService,
    TankDeliveryNoteService,
    TankService,
    PetrolStatisticsService,
    PetrolDiscountTransactionService,
    PetrolSettlementReportService,
    SurveillanceService,
    Globals,
    SidebarGeneratorService,
    IncidenceService,
    SergasDeviceService,
    SergasDeviceValuelistService,
    IPetrolDemoService,
    DatePipe,
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig }
    ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
